var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#d89f5b;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.67,87.37a7.05,7.05,0,0,1,5.66-2.88,7,7,0,0,1,6.92,6.92c0,6.93-12.58,14.89-12.58,14.89s-12.57-8-12.57-14.89A6.94,6.94,0,0,1,69,84.49,7,7,0,0,1,74.67,87.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.73,50.71c1.37,7,10.57,13.23,19.82,12.71C71.86,63.07,77.79,56,77.79,46a30,30,0,0,0-1.2-8.51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,51.86C35.7,47.45,28.3,33.61,32.74,23.49c1.21-2.76,5.13-7.19,9.86-6.57C42.6,9.86,50,7.4,57.12,7.11,69.61,6.61,81.27,14.75,86.43,23c6.06,9.68,1.44,25.75,1.44,25.75s-17.13-22.2-38.63-24.5c-2.39-.26.89,1.07,1.81,3.5,2.08,5.65-1.75,10.73-2.56,10.5-.37-2.82-2.85-6.2-7-4.82-5.94,3.07-2.62,11.5,1.5,13.25C43,49.3,43.74,52.8,43,51.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.44,63.41,63,74.72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.33,56.38l-1.73,8C37.87,66.76,38.33,72,41.33,75c8.07,8.31,26.54,6.81,24.23-2.54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.63,66.88c5.2,1.5,13.16,5.42,15.58,13.61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.3,95.8c0-12.56,5.76-30.54,32.3-31.46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.37,54.41c-.81,4-7.85,3.81-11.54-2.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.93,37.3C42.18,35.49,40,39.55,42.8,42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.52,39.53c2.19-.58,6.22,0,8.06,2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.53,41.52c1.52-1.16,3.9-1.35,5,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm2);
export default __webpack_public_path__ + "static/media/form_2.5b2d9d7cbd26b25f23db78b0bc6cc982.svg";
export { ForwardRef as ReactComponent };